export default __webpack_public_path__ + "static/media/photo--sm--106.02e6536a.jpg";